<!-- 
    COMPONENT CARDS
-->


<!---------- SCRIPT ---------->

<script lang="ts">
    
    import type { Card } from "../models/card";
    import CardComponent from "./Card.svelte";

    export let cards: Card[];

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">

</style>
  
  
<!---------- TEMPLATE ---------->

{#each cards as cardItem}
    <CardComponent card={cardItem}/>
{/each}
